import React from 'react';

const recentChats = [
  { id: 1, name: 'Arun - Prop Firm', message: 'Let’s finalize the funding process.', unread: true },
  { id: 2, name: 'Riya (Mentor)', message: 'Call confirmed for 5PM tomorrow.', unread: false },
  { id: 3, name: 'GoldSignals24', message: 'New signal posted: XAUUSD Buy 🚀', unread: true },
];

export default function ChatPreviewBox() {
  return (
    <div className="bg-black rounded-lg shadow p-4 mb-6">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-sm font-semibold text-gray-800">💬 Recent Chats</h3>
        <a href="/chat" className="text-xs text-blue-600 hover:underline">Open Chat</a>
      </div>

      <ul className="space-y-2 text-sm">
        {recentChats.map((chat) => (
          <li
            key={chat.id}
            className={`p-2 rounded border ${chat.unread ? 'bg-yellow-50 border-yellow-300' : 'border-gray-200'}`}
          >
            <div className="font-medium text-gray-700">{chat.name}</div>
            <div className="text-xs text-gray-500 truncate">{chat.message}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}
